const mistakes = [
  'игнорирует конфликт слишком долго, надеясь, что «само рассосётся»;',
  'пытается решить всё за сотрудников, не давая им прийти к решению;',
  'сразу занимает сторону одного участника, не разобравшись в ситуации;',
  'ищет виноватого вместо реальной причины конфликта;',
  'публично выясняет отношения при всей команде;',
  'откладывает сложный разговор до момента, когда он становится неизбежным;',
  'говорит «просто договоритесь» вместо того, чтобы задать рамки обсуждения;',
  'использует должность как единственный аргумент, а не управленческий инструмент;',
  'пытается помирить людей вместо решения проблемы, из-за которой возник спор;',
  'принимает эмоциональное решение, о котором потом жалеет;',
  'не фиксирует договорённости, из-за чего конфликт возвращается;',
  'не контролирует выполнение решения и считает вопрос закрытым раньше времени.',
];

export default function ManagerMistakes() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что руководитель делает неправильно при конфликте
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Типичные ошибки, из-за которых конфликт затягивается, обостряется или возвращается снова
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mb-12">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Сильный руководитель не обязательно устраняет конфликт мгновенно. Он управляет процессом так, чтобы конфликт не разрушал результат команды.
          </p>
        </div>
      </div>
    </section>
  );
}